import PropTypes from 'prop-types';
import listingPropTypes from 'components/listing/prop_types';

const AssignmentPropTypes = {
  assignment: PropTypes.shape({
    id: PropTypes.number.isRequired,
    requirement: PropTypes.shape({
      assignmentTitle: PropTypes.string.isRequired,
      assetTypeLabel: PropTypes.string.isRequired,
      capRate: PropTypes.number,
      companyType: PropTypes.string,
      fiveYearCashYieldThreshold: PropTypes.number,
      id: PropTypes.number.isRequired,
      irr: PropTypes.number,
      locationLabel: PropTypes.string.isRequired,
      priceRange: PropTypes.string,
      rentRange: PropTypes.string,
      stabilizedCapRate: PropTypes.number,
    }).isRequired,
    status: PropTypes.string.isRequired,
    statusLabel: PropTypes.string.isRequired,
    listing: listingPropTypes
  })
};

export default AssignmentPropTypes;
